import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import React from "react";
import {SxProps} from "@mui/material";

type Props = {
  title?: string
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
  children: React.ReactNode
  sx?: SxProps
}

export default function GridPaper({title, xs, sm, md, lg, xl, children, sx}: Props) {
  return (
      <Grid item xs={xs ?? 12} sm={sm ?? undefined} md={md ?? undefined} lg={lg ?? undefined}
            xl={xl ?? undefined}>
        <Paper sx={{...sx, height: "100%", boxSizing: "border-box"}}>
          {title &&
              <h3>{title}</h3>
          }
          <div>{children}</div>
        </Paper>
      </Grid>
  );
}